var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13,
    viewBox: "0 0 17 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68BD53",
    fillRule: "nonzero",
    d: "M15.438 0a1.504 1.504 0 0 0-1.042.474c-2.937 3-5.616 5.95-8.453 8.895L2.465 6.54a1.494 1.494 0 0 0-1.5-.232 1.561 1.561 0 0 0-.396 2.647l4.55 3.709c.603.49 1.472.44 2.018-.116 3.265-3.336 6.197-6.618 9.4-9.89.45-.444.587-1.124.344-1.712A1.515 1.515 0 0 0 15.438 0z"
  })));
}

export default SvgCheckmark;